import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import LdsButton from "../../components/LdsButton";
import { SideBar } from "../../components/SideBar";
import { useSelector } from "react-redux";

import { ReactLoaderSpinner } from "../../components/ReactLoaderSpinner/index.js";
import LdsVideoPlayer from "../../components/LdsVideoPlayer";
import LdsFigureCaption from "../../components/LdsFigureCaption";
import LdsKalturaPlayer from "../../components/LdsVideoPlayer/KalturaPlayer";

// services
import { useBookmarkModuleMutation } from "../../store/services/moduleServerApi";

const Module_2_1_1 = () => {
  const { pathname: pathName } = useLocation();
  const { menuItems } = useSelector((state) => state?.moduleSlice);

  const [bookmarkModule, { isLoading: isMenuLoading }] =
    useBookmarkModuleMutation();

  /* Start useEffect */
  useEffect(() => {
    bookmarkModule({ pathName });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // * onPageLoad
  /* End useEffect */

  return (
    <div className="row">
      {isMenuLoading && <ReactLoaderSpinner />}
      {menuItems?.id && <SideBar menuItems={[menuItems]} />}
      <div className="col-sm-8">
        <main className="module-content">
          <section>
            <h1 className="blue text-uppercase b mt-5 mb-4">
              2.3.7 Demonstration Case 5: Complications Caused by Atrophy
            </h1>
            <p className="me-4">Estimated time to complete: 3-4 minutes</p>
          </section>

          <section className="row justify-content-center">
            <div className="col-lg-8 col-sm-12 mt-4 mb-4">
              <LdsFigureCaption
                textContent={
                  <>
                    <p>
                      <strong>AUDIO</strong>
                      <br />
                      VO: (FEMALE)
                      <br />
                    </p>
                    <p>
                      This is Demonstration Case Number 5. This is a positive
                      case. The size and contrast have already been adjusted.
                      Starting at the bottom and entering into the cerebellum,
                      identify the normal gray-white contrast for this patient.
                      In this case, it is particularly dramatic, as there is
                      very faint activity in the cerebellar gray matter.
                    </p>
                    <p>
                      Moving up, you enter into the temporal lobes bilaterally.
                      There is significant noise on this scan which makes
                      evaluation difficult. However, it is immediately clear
                      that the white matter tracts are not easily identifiable.
                      Therefore, there is loss of gray-white contrast in the
                      temporal lobes bilaterally.
                    </p>
                    <p>
                      As we move even more superiorly and enter into the
                      occipital region, white matter tracts can be seen on the
                      left as well as on the right. In addition, less intense
                      activity is seen in the adjacent gray matter bilaterally.
                      Therefore, there is preserved gray-white contrast in the
                      occipital lobes.
                    </p>
                    <p>
                      As we move our attention to the frontal lobes, multiple
                      slices show potentially preserved gray-white contrast.
                      However, there are slices that do not show normal
                      gray-white contrast, as can be seen here. On the left-hand
                      side, this appears to have normal gray-white contrast;
                      however, it is important to exclude any confounding
                      pathology, such as atrophy.
                    </p>
                    <p>
                      Moving to the fused images, for this particular slice, you
                      can see that, in fact, this particular area corresponds to
                      CSF. In addition, other slices also indicate the presence
                      of large CSF spaces, secondary to the presence of atrophy.
                      Therefore, there is loss of gray-white contrast in the
                      left frontal region.
                    </p>
                    <p>
                      Moving inferiorly a few slices and looking at the right
                      frontal region, there appears to be loss of gray- white
                      contrast. Again, utilizing the fused images, it is clear
                      that increased activity is seen extending to the periphery
                      and within the brain matter.
                    </p>
                    <p>
                      Therefore, there is loss of gray-white contrast in the
                      right frontal lobe as well. It is important to remember
                      that fused and CT images should be used only as an adjunct
                      for localization purposes when interpreting a PET Amyvid
                      scan. The final determination should be based upon
                      interpretation of the black and white PET images.
                    </p>
                    <p>
                      Returning to the PET images and moving superiorly into the
                      parietal regions, increased activity is seen extending to
                      the periphery in the right posterior parietal region. This
                      pattern is also seen on the left-hand side.
                    </p>
                    <p>
                      It is important to review all slices, and as we proceed
                      superiorly, we examine all parietal slices. Therefore,
                      after reviewing the entire brain, there is loss of
                      gray-white contrast in the parietal lobes, frontal lobes,
                      and temporal regions. This scan is, therefore, positive.
                    </p>
                  </>
                }
                buttonIcon="MinusCircle"
                buttonTextAlign="left"
                showDescriptionText="Video Transcript"
                hideDescriptionText="Video Transcript"
                radiusSize="small"
              >
                <LdsVideoPlayer brandBorder={false}>
                  <LdsKalturaPlayer
                    videoId="1_ddci7ux1"
                    partnerId="1759891"
                    uiConfId="54959122"
                    nextUrl="/module-2/module-2-3-8"
                  />
                </LdsVideoPlayer>
              </LdsFigureCaption>
            </div>
          </section>

          <section className="button-control">
            <LdsButton
              classes="white-button mt-3 mb-5 prev"
              onClick={function navClick() {
                window.open("/module-2/module-2-3-6", "_self");
              }}
            >
              Previous Lesson
            </LdsButton>
            <LdsButton
              id="next"
              classes="blue-button mt-3 mb-5 align-self-right float-end next"
              disabled={true}
            >
              Next Lesson
            </LdsButton>
          </section>
        </main>
      </div>
    </div>
  );
};

export default Module_2_1_1;
